module.exports = __webpack_public_path__ + "static/media/ios.04f6d302.png";